/**
 * Token centinela usado por el mecanismo anti-enumeración de usuarios (ARBCMFIMP-18419).
 *
 * Cuando el documento o el usuario ingresados en el step 1 no son válidos, el flujo
 * igualmente avanza al step 2 con este token en lugar de un exchange token real. Así,
 * a nivel UX y de red, el caso "usuario inexistente" es indistinguible de "usuario válido
 * con credenciales incorrectas".
 *
 * Cualquier saga que dependa del exchange token debe verificar este valor antes de llamar
 * al backend, ya que no representa una sesión válida.
 */
export const NOTOKENLOGIN = "notokenlogin";

/**
 * Indica si el exchange token es el centinela anti-enumeración y, por lo tanto, no debe
 * usarse para llamadas autenticadas al backend.
 *
 * @param {string} exchangeToken
 * @returns {boolean}
 */
export const isSimulatedLoginToken = (exchangeToken) => exchangeToken === NOTOKENLOGIN;
